module.exports = __webpack_public_path__ + "img/menucn_1_4.ec202a70.svg";